import * as Phaser from 'phaser';
import { PhaserCombatSequencer } from '../../PhaserCombatSequencer';

export interface ICombatAdapter {
  started(data: { combatId: string; attackerId: string; defenderId: string; attackerColor?: string; defenderColor?: string; attackerWeapon?: any; defenderWeapon?: any }): void;
  damage(data: { combatId: string; attackerId: string; defenderId: string; damage?: number; isCritical?: boolean; attackerColor?: string; defenderColor?: string; weaponUsed?: { type: string } | null }): void;
  miss(data: { combatId: string; attackerId: string }): void;
  ended(data: { combatId: string; winner: string; loser: string }): void;
  isAgentInActiveCombat?(agentId: string): boolean;
}

export class CombatAdapter implements ICombatAdapter {
  constructor(
    private readonly scene: Phaser.Scene,
    private readonly sequencer: PhaserCombatSequencer
  ) {}

  started(data: any): void {
    console.log(`🎭 CombatAdapter.started: 接收到武器数据 attackerWeapon=${!!data.attackerWeapon}, defenderWeapon=${!!data.defenderWeapon}`);
    if (data.attackerWeapon) console.log(`🗡️ 攻击者武器:`, data.attackerWeapon);
    if (data.defenderWeapon) console.log(`🛡️ 防御者武器:`, data.defenderWeapon);
    this.sequencer.handleCombatStarted(data);
  }
  damage(data: any): void { this.sequencer.handleCombatDamage(data); }
  miss(data: any): void { this.sequencer.handleCombatMiss(data); }
  ended(data: any): void { this.sequencer.handleCombatEnded(data); }

  // 供Engine延迟死亡判断调用
  isAgentInActiveCombat(agentId: string): boolean {
    try { return (this.sequencer as any).isAgentInActiveCombat?.(agentId) === true; } catch { return false; }
  }
}
